import { sharedRequests } from "@/api/(requests)/shared";

export const reportCreditCardError = async (description, error_message) => {
  try {
    let report = {
      context: {
        error_message: error_message,
      },
      description: description,
      type: "credit_card_frontend_error",
    };

    await sharedRequests.post_exception_report({ report });
  } catch (e) {
    console.log(e);
  }
};
